interface IconProps {
  iconName: string;
  size?: number;
  modifierCss?: string;
}

const Icon = ({ iconName, size, modifierCss = '' }: IconProps) => {
  const cssSize = size ? `icon--${size}` : '';
  const cacheBuster = global.cacheBuster;

  function createMarkup() {
    return {
      __html: `<use xlink:href="/bundles/svg/sprite.svg?cb=${cacheBuster}#${iconName}"></use>`
    };
  }

  return (
    <svg
      className={`icon ${cssSize} ${modifierCss}`}
      dangerouslySetInnerHTML={createMarkup()}
    />
  );
};

export default Icon;
